import { AppError } from "./app-error";

export class NotFoundError extends AppError {}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/pages/common/not-found-error.ts